import { createSelector } from "@reduxjs/toolkit";

export const signupState = (state) => state.signup;

export const signupSelectors = createSelector(signupState, (state) => state);
